import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

const Playbill = props => {
  // TODO: a => buttons
  const elements = props.timetable.map(e => {
    const classes = ['timetable__item'];
    if (props.current == e.id) classes.push('timetable__item--open');
    if (e.format == '3d') classes.push('timetable__item--3d');
    if (e.format === 'screenx') classes.push('timetable__item--screenx');

    return (
      <div key={e.id} className={classes.join(' ')}>
        <a style={{ cursor: 'pointer' }} onClick={() => props.onChange(e.id)}>
          <span>{e.time}</span>
          <span className="price">
            {e.price_min == e.price_max
              ? `${e.price_min}`
              : `от ${e.price_min}`}{' '}
            &#x20BD;
          </span>
        </a>
      </div>
    );
  });

  return (
    <div className="scheme-popup__timetable">
      <Scrollbars
        style={{ width: '100%' }}
        autoHeight
        className="track-horizontal"
      >
        <div className="timetable-line__stage timetable-line__stage--popup">
          {elements}
        </div>
      </Scrollbars>
      {/*<div className="timetable-line__nav">
        <button className="timetable-line__btn timetable-line__btn--prev timetable-line__btn--disabled" type="button">
          <svg viewBox="0 0 20 23" width="20" height="23">
            <path d="M16.5 23c-.6 0-1.2-.2-1.7-.5l-13-7.7c-.9-.6-1.5-1.5-1.7-2.6-.2-1 0-2.1.6-3 .3-.3.8-.8 1.1-1l13-7.7c1.1-.7 2.5-.6 3.6.1 1 .8 1.6 1.9 1.6 3.2v15.4c0 1.2-.6 2.4-1.6 3.2-.6.4-1.2.6-1.9.6zm-13.1-12.2l-.2.2c-.2.2-.2.5-.2.7s.2.5.4.6l12.9 7.7c.1.1.2.1.3 0 .2-.2.3-.4.3-.7v-15.5c0-.3-.1-.6-.4-.7.1-.1-.1-.1-.2-.1l-12.9 7.8z"></path>
          </svg>
        </button>
        <button className="timetable-line__btn timetable-line__btn--next" type="button">
          <svg viewBox="0 0 20 23" width="20" height="23">
            <path d="M1.6 22.4c-1-.8-1.6-2-1.6-3.2v-15.4c0-1.3.6-2.4 1.6-3.2 1.1-.7 2.5-.8 3.6-.1l13 7.7c.3.2.8.7 1.1 1 .6.9.8 2 .6 3-.2 1.1-.8 2-1.7 2.6l-13 7.7c-.5.3-1.1.5-1.7.5-.7 0-1.3-.2-1.9-.6zm2.1-19.4c-.1 0-.3 0-.2.1-.3.1-.4.4-.4.7v15.5c0 .3.1.5.3.7.1.1.2.1.3 0l12.9-7.7c.2-.1.4-.4.4-.6s0-.5-.2-.7l-.2-.2-12.9-7.8z"></path>
          </svg>
        </button>
      </div>*/}
    </div>
  );
};

export default Playbill;
